module.exports = __webpack_public_path__ + "img/w_corporation.e85b3f8c.png";